export var LegacyCommPreferencesAdaptor = function(personData) {
    var commPreferences = {};
    
    // Constructor
    if (personData) {
        commPreferences.languagePreference = personData.preferredLanguage;
        commPreferences.marketingEmail = personData.preferences.acceptMarketingEmail;
        commPreferences.marketingSMS = personData.preferences.acceptMarketingSMS;
        commPreferences.contactPreference = personData.preferences.contactPreference;
    }

    // -----------------------------------------------------
    //
    //                 Public Methods
    //
    // -----------------------------------------------------

    // -----------------------------------------------------
    //
    //                 Private Methods
    //
    // -----------------------------------------------------

    return commPreferences;
};



//////////////////
// WEBPACK FOOTER
// /Users/geoffsagers/dev/webcomponents/js/packages/common-account/src/models/adaptors/legacyCommPreferencesAdaptor.js
// module id = 41
// module chunks = 0